import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import ScrollContainer from 'react-indiana-drag-scroll';
import { useRecoilValue } from 'recoil';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

import { auth } from '@constants/state';
import { PORTFOLIO_DETAIL_CAPITAL_CHANGE_LIST_HEADER } from '@constants/tableheader';

/** 포트폴리오 상세 > 자본금 변동내역 > 목록 스켈레톤 */
const CapitalChangeListSkeleton = () => {
  const { role } = useRecoilValue(auth);

  const tableData = useMemo(
    () =>
      Array.from({ length: 10 })?.map((_: any, i: number) => ({
        id: i,
        no: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        issueDate: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        name: (
          <div css={items}>
            <Skeleton variant="text" width={50} />
          </div>
        ),
        type: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        stockType: (
          <div css={items}>
            <Skeleton variant="text" width={120} />
          </div>
        ),
        capital: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        faceValue: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        issuanceQuantity: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        accumulatedIssuanceQuantity: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        sellingPrice: (
          <div css={items}>
            <Skeleton variant="text" width={60} />
          </div>
        ),
        corporateValue: (
          <div css={items}>
            <Skeleton variant="text" width={120} />
          </div>
        ),
        delete: (
          <div css={deleteButton}>
            <Skeleton
              variant="rectangular"
              width={64}
              height={34}
              sx={{ borderRadius: '5px' }}
            />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div css={[titleStyle, { justifyContent: 'space-between' }]}>
        <Skeleton variant="text" width={60} />
        <Skeleton
          variant="rectangular"
          width={88}
          height={34}
          sx={{ borderRadius: '5px' }}
        />
      </div>

      <ScrollContainer css={tableWrap} hideScrollbars={false}>
        <Table
          header={
            role === 'ROLE_PARTNER'
              ? PORTFOLIO_DETAIL_CAPITAL_CHANGE_LIST_HEADER.filter(
                  (d: any) => d.value !== 'delete'
                )
              : PORTFOLIO_DETAIL_CAPITAL_CHANGE_LIST_HEADER
          }
          data={tableData}
        />
      </ScrollContainer>
    </>
  );
};

export default CapitalChangeListSkeleton;

const tableWrap = css`
  border-radius: 5px 5px 0 0;
  overflow-x: auto;
  padding: 1px;
  &::-webkit-scrollbar {
    width: 4px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.gray4};
    height: 30%;
  }
  &::-webkit-scrollbar-track {
    background: ${palette.gray3};
  }

  table {
    width: calc(1920px - 250px - 82px);
  }
`;

const deleteButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    background-color: ${palette.colorDanger};
    &:hover,
    &:active {
      background-color: ${palette.colorDanger};
      opacity: 0.8;
    }
  }
`;

const items = css`
  display: flex;
  justify-content: center;
`;
